
import { i18nText } from '@/locales';

import {checkUserRole, getUserData} from '@/router/Lib/helper';
import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {salonTabs} from "@/utils/tabs";
import {SalonsStore} from "@/store/modules/Salons";
import {ISalonsListItem} from "@/entity/salons/salons.types";
import {message} from "ant-design-vue";
import {RouterNameEnum} from "@/router/router.types";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {mixins} from 'vue-class-component'
import {FormMix} from '@/UI/mixins/FormMix'
import {getStudioId} from '@/UI/lib/state';
import {ProxyGetData} from '@/UI/components/Helpers/getData';

@Component({
  components: {
    PageTitle,
    BaseDataForm
  },
  methods: {
    checkUserRole,
    getUserData,
  },
})

export default class SalonDetail extends mixins(
    FormMix,
    ProxyGetData
) {
  tabs = salonTabs

  async deleteSalon(): Promise<void> {
    const response = await SalonsStore.delete({id: parseInt(this.$route.params.id)})
    if (response.status) {
      message.success(i18nText("Данные успешно удалены"));
      await this.$router.push({
        name: RouterNameEnum.Salons,
        params: {
          Studio: getStudioId(this)
        }
      })
    } else {
      message.error(i18nText("Ошибка, студию нельзя удалить т.к есть связанные сущности"));
    }
  }

  async tabChanged(key: string): Promise<void> {
    try {
      this.formReady = false
      let params: any = {
        id: String(Vue.router.currentRoute.params['id']),
        page: '1',
        total: '10',
        filter: '{}',
        sorted: '{}'
      }
      if (key === 'SalonDetailFinancePage') {
        params.filter = JSON.stringify({
          salon_id: Vue.router.currentRoute.params.id
        })
        params.sorted = JSON.stringify({
          sort: 'date',
          by: 'desc'
        })
      }
      if (key === 'SalonDetailClientsPage') {
        params.filter = JSON.stringify({
          salon_id: Vue.router.currentRoute.params.id
        })
        params.sorted = JSON.stringify({
          sort: 'created_at',
          by: 'desc'
        })
      }

      await Vue.router.push({
        name: key,
        params: params
      })
    } catch (e) {
      console.error(e)
    } finally {
      this.formReady = true
    }
  }

  get salon(): ISalonsListItem | null {
    return SalonsStore.salon
  }

  async created(): Promise<void> {
    try {
      /*this.proxyFilter = {
        id: getStudioId(this)
      }
      await this.getData()
      await Vue.router.push({
        name: 'SalonDetail',
        params: {
          id: getStudioId(this)
        }
      })*/
      this.formReady = true
    } catch (e) {
      console.error(e)
    }
  }
}
